const contentProps = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  textAlign: 'center',
  height: 5,
  fontSize: 3,
  borderRadius: 6,
  border: 0,
  outline: 0
}

export default contentProps
